module.exports = __webpack_public_path__ + "static/img/2.057ba11a.jpeg";